import ClothListContainer from "../../../../Componant/Application/Ecommerce/master/ClothListContainer"

const ClothList = () => {
  return (
    <div className='page-body'>
      <ClothListContainer />
    </div>
  )
}

export default ClothList